import styles from "./SubsidyIndividualWarning.module.css";
import infoIcon from "../../assets/icons/info.svg";
import { useI18n } from "../../i18n";
import classNames from "classnames";
interface SubsidyIndividualWarningProps {
  subsidyBoxClickHandler: () => void;
}
const SubsidyIndividualWarning = (props: SubsidyIndividualWarningProps) => {
  const { t } = useI18n();

  return (
    <button
      id="btn-subsidy-individual-message"
      className={classNames(styles.container, styles.isClickable)}
      onClick={props.subsidyBoxClickHandler}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          props.subsidyBoxClickHandler();
        }
      }}
    >
      <div className={styles.header}>
        <img src={infoIcon} alt={"info icon"} className={styles.icon} />
        <span className={styles.title}>{t("savings.subsidy.individual.message")}</span>
      </div>
    </button>
  );
};

export { SubsidyIndividualWarning };
